<template>
    <div class="ei-num">
        <span :class="{before:isBefore,after:isAfter}" :data-before="countBefore"
              :data-after="countAfter">{{count}}</span>
    </div>
</template>

<script>
    export default {
        name: "EiNum",
        data() {
            return {
                count: 0,
                countBefore: 0,
                countAfter: 0,
                isBefore: false,
                isAfter: false,
                timer: null,
            }
        },
        props: {
            start: {
                type: Number,
                default: 0
            },
            end: {
                type: Number,
                required: true
            }
        },
        watch: {
            end(newV, oldV) {
                this.count = oldV
                this.end = newV
                this.countBefore = this.count - 1
                this.countAfter = this.count + 1
                this.setTimer()
            }
        },
        created() {
            this.count = this.start
            this.countBefore = this.count - 1
            this.countAfter = this.count + 1
            this.setTimer()
        },
        methods: {
            subtract() {
                this.isBefore = true
                setTimeout(() => {
                    this.count--
                    this.countBefore = this.count - 1
                    this.countAfter = this.count + 1
                    this.isBefore = false
                }, 400)
            },
            add() {
                this.isAfter = true
                setTimeout(() => {
                    this.count++
                    this.countBefore = this.count - 1
                    this.countAfter = this.count + 1
                    this.isAfter = false
                }, 400)
            },
            setTimer() {
                this.timer = setInterval(() => {
                    if (this.count === this.end) {
                        clearInterval(this.timer)
                    } else if (this.count < this.end) {
                        if (!this.isBefore && !this.isAfter) {
                            this.add()
                        }
                    } else {
                        if (!this.isBefore && !this.isAfter) {
                            this.subtract()
                        }
                    }
                }, 500)
            }
        }
    }
</script>

<style scoped lang="scss">
    .ei-num {
        display: inline-block;
        width: 25px;
        height: 38px;
        overflow: hidden;
        position: relative;

        span {
            display: block;
            font-size: 38px;
            line-height: 38px;
            text-align: center;
            transform: translateY(-38px);
        }

        span.before {
            transform: translateY(0px);
            transition: transform 400ms ease-in;
        }

        span.after {
            transform: translateY(-76px);
            transition: transform 400ms ease-in;
        }

        span::before {
            display: block;
            content: attr(data-before);
        }

        span::after {
            display: block;
            content: attr(data-after);
        }
    }
</style>
